/* eslint-disable react/no-unknown-property */
import React from 'react';
import { ICarouselSlide } from '../../../../../types';
import { PictureInPicture } from '../../../../pictureInPicture/pictureInPicture';
import { SmartImage } from '../../../../sharedComponent/smartImage/smartImage';

function CarouselSlide(props: ICarouselSlide) {
    const image = (
        <SmartImage
            className={props.className}
            alt={props.alt}
            src={props.src}
            srcSet={props.srcSet}
            key={props.slideIndex}
            fetchpriority={props.slideIndex === 0 ? 'high': undefined}
        />
    );

    return (props.showPIPicons && !props.displayMediaOverlay) ? (
        <PictureInPicture>
            {image}
        </PictureInPicture>
    ) : <>{image}</>;
}

export default CarouselSlide;
